<!--
Important:
This Component is used only for the Vue3 application
Any modifications made should be done for Vue2 component also
Vue2File: wwwroot\js\components\Review\RotationalGoogleReview.vue
Dont forget to make the changes in both the files
Any clarifications contact Laxman
-->
<template>
  <div class="bg-white">
    <div class="pt-4 pb-4 pb-lg-0 container">
      <div class="text-center mb-4 rotational-coupon-specials">
        <h2 class="m-0 p-o font-weight-bold">{{ title }}</h2>
        <div class="rotational-coupon-specials-links text-right">
          <a
            href="/google-reviews"
            class="ft-12 color-black mr-3 rotational-coupon-service-link cust-link btn-websites button-link text-underline d-block text-center text-md-right my-2 my-md-0 d-md-inline"
          >
            Read all reviews
          </a>
        </div>
      </div>
      <VSlickCarousel v-if="reviewData" ref="slick" v-bind="slickOptions" prefix="slick">
        <template #prevArrow="arrowSlotProps">
          <div
            @click="arrowSlotProps.onClick()"
            :disabled="arrowSlotProps.disabled"
            v-html="prevArrowHTML"
          ></div>
        </template>
        <template #nextArrow="arrowSlotProps">
          <div
            @click="arrowSlotProps.onClick()"
            :disabled="arrowSlotProps.disabled"
            v-html="nextArrowHTML"
          ></div>
        </template>
        <div v-for="(item, index) in reviewData" :key="index">
          <div class="m-3 p-4 d-flex flex-column border" style="height: 375px">
            <div class="d-flex justify-content-between">
              <div class="w-60">
                <h2 class="_theme_font_bold ft-18 mt-2 d-flex align-items-center text-uppercase">
                  <span class="primaryicon-google-icon-colors pr-2"
                    ><span class="path1 primaryicon-google-icon-colors"></span
                    ><span class="path2 primaryicon-google-icon-colors"></span
                    ><span class="path3 primaryicon-google-icon-colors"></span
                    ><span class="path4 primaryicon-google-icon-colors"></span></span
                  >{{ item?.reviewer?.displayName }}
                </h2>
                <div class="ft-12">{{ getDate(item?.createTime) }}</div>
              </div>
              <div class="d-inline">
                <span class="pr-2" v-for="index in stars" :key="index">
                  <em
                    class="primaryicon-star-yellow"
                    title="star-yellow"
                    v-if="index <= starRatings[item?.starRating]"
                  ></em>
                  <em class="primaryicon-star-gray" title="star-gray" v-else></em>
                </span>
              </div>
            </div>
            <div class="comment-section mt-4">{{ item?.comment }}</div>
          </div>
        </div>
      </VSlickCarousel>
      <div v-else class="row mb-5 mt-2 mr-2 ml-2">
        <div class="col-md-12 mt-4"><div class="alert alert-warning">No Reviews Data</div></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "v-slick-carousel/style.css";
import { VSlickCarousel } from "v-slick-carousel";
export default {
  components: {
    VSlickCarousel,
  },
  data() {
    return {
      slickOptions: {
        infinite: true,
        groupsToShow: 1,
        groupsToScroll: 1,
        dots: false,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              groupsToShow: 3,
              groupsToScroll: 3,
            },
          },
          {
            breakpoint: 767,
            settings: {
              groupsToShow: 2,
              groupsToScroll: 2,
            },
          },
        ],
      },
      stars: [1, 2, 3, 4, 5],
      starRatings: {
        ONE: 1,
        TWO: 2,
        THREE: 3,
        FOUR: 4,
        FIVE: 5,
      },
      reviewData: null,
      reviewMinimumRating: window.reviewMinimumRating,
      title: window.googleReviewsTitleText || "Reviews",
    };
  },
  computed: {
    nextArrowHTML() {
      const themeClass =
        window.themeName?.toLowerCase() === "mazda_oem"
          ? "primaryicon-right-arrow"
          : "primaryicon-right-arrow-light";
      return `<em class="${themeClass} d-md-block ft-24 position-absolute" style="cursor:pointer;z-index:1;right:-20px;top:45%;color:rgb(0,0,0)!important;background:rgba(255,255,255,0)!important;"></em>`;
    },
    prevArrowHTML() {
      const themeClass =
        window.themeName?.toLowerCase() === "mazda_oem"
          ? "primaryicon-left-arrow"
          : "primaryicon-left-arrow-light-format";
      return `<em class="${themeClass} d-md-block ft-24 position-absolute" style="cursor:pointer;z-index:1;left:-20px;top:45%;color:rgb(0,0,0)!important;background:rgba(255,255,255,0)!important;"></em>`;
    },
  },
  mounted() {
    this.getGoogleReviews();
  },
  methods: {
    getGoogleReviews() {
      const url = `${window.ApiBaseUrl}/googlebusiness/reviews?campaignid=${window.campaignId}`;

      axios.get(url).then((response) => {
        this.reviewData = response?.data?.reviews?.filter(
          (item) => this.reviewMinimumRating <= this.starRatings[item?.starRating]
        );
      });
    },
    getDate(date) {
      const parsedDate = new Date(date);
      const options = { year: "numeric", month: "long", day: "numeric" };
      const formattedDate = parsedDate.toLocaleDateString("en-US", options);
      return formattedDate;
    },
  },
};
</script>

<style>
.comment-section {
  max-height: 260px;
  overflow: auto;
  font-size: 1rem;
}
.w-60 {
  width: 60%;
}
.primaryicon-google-icon-colors {
  font-size: 28px;
  letter-spacing: 0px;
}
</style>
